// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Homepage-module--bx--text-truncate--end--dAGoT";
export var bxTextTruncateFront = "Homepage-module--bx--text-truncate--front--iYzmk";
export var calloutLink = "Homepage-module--callout-link--vguwx";